export const isForwardedAudio = contentAttributes =>
  !!contentAttributes?.forwarded;

export const getAudioAppearance = ({ contentAttributes, isOutgoing }) => {
  if (isForwardedAudio(contentAttributes)) return 'forwarded';
  return isOutgoing ? 'outgoing' : 'incoming';
};

export const getAudioAvatarIdentity = ({
  contentAttributes,
  sender,
  inbox,
  conversation,
  isOutgoing,
}) => {
  if (contentAttributes?.auroraAi ?? contentAttributes?.aurora_ai) {
    return { name: 'IA', src: '' };
  }

  if (inbox?.channel_type === 'Channel::Api' && isOutgoing) {
    const assignee = conversation?.meta?.assignee;
    if (assignee) {
      return {
        name: assignee.name || '',
        src: assignee.thumbnail || assignee.avatar_url || '',
      };
    }
  }

  return {
    name: sender?.name || '',
    src: sender?.thumbnail || sender?.avatar_url || sender?.avatarUrl || '',
  };
};
